import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { SheetSettings } from "./SheetSettings";
import { TeamSheetTable } from "./TeamSheetTable";
import { PickerDetail } from "./PickerDetail";
import { LostLeaderboard } from "./LostLeaderboard";
import { GapHeatmap } from "./GapHeatmap";
import { QuarterReview } from "./QuarterReview";
import { NewStarters } from "./NewStarters";
import { OvertimeView } from "./OvertimeView";
import { MetricToggle } from "./MetricToggle";
import { computeSheet } from "../lib/pickerSheet";

export const PickerSheet = ({ raw, from, to, cfg, setCfg }) => {
  const [userId, setUserId] = useState(null);
  const [view, setView] = useState("team");
  const users = useMemo(() => computeSheet(raw.days, from, to, cfg), [raw.days, from, to, cfg]);
  if (!raw.hasTime || !raw.days) return (
    <div className="panel p-8 max-w-2xl" data-testid="sheet-needs-time">
      <Clock className="h-6 w-6 text-amber-400" />
      <h3 className="font-display text-xl font-semibold text-slate-100 mt-3">Picker sheet needs pick times</h3>
      <p className="text-sm text-slate-400 mt-2">Re-upload your CSV on the Manage data page and map the Time column so daily start/finish, hours worked and gaps can be calculated.</p>
      <Link to="/manage" data-testid="sheet-go-manage" className="mt-5 inline-flex px-4 py-2 rounded-md bg-ep hover:bg-ep-hover text-white text-sm">Go to Manage data</Link>
    </div>
  );
  const user = users.find((u) => u.id === userId);
  return (
    <div className="space-y-6">
      <div className="no-print"><SheetSettings cfg={cfg} setCfg={setCfg} /></div>
      {user ? <PickerDetail users={users} user={user} cfg={cfg} onSelect={setUserId} onBack={() => setUserId(null)} /> : <>
        <div className="no-print"><MetricToggle value={view} onChange={setView} options={[["team", "Team sheet"], ["leaderboard", "Lost time leaderboard"], ["heatmap", "Gap heatmap"], ["quarters", "Quarter review"], ["starters", "New starters"], ["overtime", "Overtime"]]} prefix="sheet-view" /></div>
        {view === "team" && <TeamSheetTable users={users} onOpen={setUserId} />}
        {view === "leaderboard" && <LostLeaderboard users={users} onOpen={setUserId} />}
        {view === "heatmap" && <GapHeatmap users={users} />}
        {view === "overtime" && <OvertimeView users={users} cfg={cfg} onOpen={setUserId} />}
        {view === "starters" && <NewStarters raw={raw} cfg={cfg} onOpen={setUserId} />}
        {view === "quarters" && <QuarterReview raw={raw} months={raw.months.filter((m) => m >= from && m <= to)} cfg={cfg} onOpen={setUserId} />}
      </>}
    </div>
  );
};
